import { FC } from 'react';
import { Flex } from 'antd';
import {
  SDropdown,
  ErrorMessage,
  SLabelTitle,
  ModalDialog,
  SDatePicker,
  SInput,
} from '../..';
import { IProps } from './type';
import styles from '../../../assets/styles/index.module.scss';
import dayjs from 'dayjs';
import { useAppSelector } from '../../../store';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMAT } from '../../../assets/conts';
import globalStyles from '../../../assets/styles/index.module.scss';
import { useSetOrganizationOnOpen } from '../../../hooks';

dayjs.extend(customParseFormat);

const ReconciliationModal: FC<IProps> = (props) => {
  const { getFieldProps, setFieldValue, values, errors, touched } =
    props.formik;
  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  useSetOrganizationOnOpen(props.open, values, setFieldValue);

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex align="flex-start" justify="space-between">
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Flex vertical gap="small">
            <SDropdown
              id="organization"
              value={
                props.organizations.find(
                  (item) =>
                    item.id ===
                    (values.organization ||
                      (organization !== 1 ? organization : undefined)),
                )?.name
              }
              placeholder="Şirket Seçiniz"
              className={globalStyles.width200px}
              disabled={organization !== 1}
              options={props.organizations.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(value) => setFieldValue('organization', value)}
            />
            {touched.organization && errors.organization && (
              <ErrorMessage>{errors.organization}</ErrorMessage>
            )}
          </Flex>
        </Flex>
        <Flex gap="small" vertical>
          <SLabelTitle>Cari Bilgiler</SLabelTitle>
          <SDropdown
            id="current_account"
            value={values.current_account}
            placeholder="Cari Bilgi Seçiniz"
            options={props.currentAccounts.map((item) => ({
              value: item.key,
              label: item.value,
            }))}
            onChange={(value) => setFieldValue('current_account', value)}
          />
          {touched.current_account && errors.current_account && (
            <ErrorMessage>{errors.current_account}</ErrorMessage>
          )}
        </Flex>
        <Flex gap="small" vertical>
          <SLabelTitle>Mutabakat Bilgileri</SLabelTitle>
          <SDatePicker
            id="reconciliation_date"
            value={
              values.reconciliation_date
                ? dayjs(values.reconciliation_date, DATE_FORMAT)
                : null
            }
            placeholder="Mutabakat Tarihi"
            onChange={(date) => {
              if (date) {
                setFieldValue('reconciliation_date', date.format(DATE_FORMAT));
              }
            }}
          />
          {touched.reconciliation_date && errors.reconciliation_date && (
            <ErrorMessage>{errors.reconciliation_date}</ErrorMessage>
          )}
        </Flex>
        <Flex justify="space-between" gap="small">
          <Flex vertical gap="small" className={styles.widthHalf}>
            <SInput
              type="number"
              allowNegative
              placeholder="Toplam Borç"
              {...getFieldProps('total_debt')}
            />
            {touched.total_debt && errors.total_debt && (
              <ErrorMessage>{errors.total_debt}</ErrorMessage>
            )}
          </Flex>
          <Flex vertical gap="small" className={styles.widthHalf}>
            <SInput
              type="number"
              allowNegative
              placeholder="Vadesi Geçmiş"
              {...getFieldProps('due_debt')}
            />
            {touched.due_debt && errors.due_debt && (
              <ErrorMessage>{errors.due_debt}</ErrorMessage>
            )}
          </Flex>
        </Flex>
      </Flex>
    </ModalDialog>
  );
};

export default ReconciliationModal;
